export default "/assets/site/images/favicon-32x32.png?81a12a2f791e3a2731329a1f3c8d5a7c";